import { render } from "./PartnersList.vue?vue&type=template&id=d5c53938"
import script from "./PartnersList.vue?vue&type=script&lang=js"
export * from "./PartnersList.vue?vue&type=script&lang=js"

import "./PartnersList.vue?vue&type=style&index=0&id=d5c53938&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__